module.exports = __webpack_public_path__ + "img/stock0.dda8a088.png";